import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { VisitApiService } from '../../services/visit-api.service';
import { map } from 'rxjs/operators';
import { Annex, IAnnexFile, Visit } from 'inova-front-core/models';
import { CommonHelper } from 'inova-front-core/helpers/clases';


@Component({
  selector: 'inova-visit-annexes-view',
  templateUrl: './annexes-view.component.html',
  styleUrls: ['./annexes-view.component.scss'],
})
export class AnnexesViewComponent implements OnInit {

  dataSource!: MatTableDataSource<any>;
  columnsToDisplay = ['fileName', 'actions'];
  visit: Visit;
  groupedAnnexes: any[] = [];
  extensions = [['.jpg', '.png', '.gif', '.jpeg'], ['.pdf'], ['.xls', '.xlsx'], ['.doc', '.docx']];
  hasAnnexes: boolean;
  noAnnexes = 'No hay anexos de este tipo';
  allAnnexes: any[] = [];
  generatingZip: boolean;
  loadingDialog: boolean;

  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialogRef: MatDialogRef<AnnexesViewComponent>,
              private visitService: VisitApiService) {
    this.visit = data.visit as Visit;
    this.loadingDialog = true;
    this.hasAnnexes = false;
    this.generatingZip = false;
  }

  ngOnInit() {
    const numericId = CommonHelper.getIdFromGraphId(String(this.visit.id));
    const graphId = btoa(`VisitaNode:${numericId}`);
    this.visitService.getVisit(graphId).subscribe((response: any) => {
      this.visit.anexos = response.anexosTemp.map((item: string) => JSON.parse(item));
      this.visit.anexos = this.mapAnnexes(this.visit.anexos);
      this.loadingDialog = false;
      this.getAnnexesTab(0);
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  getAnnexesTab(index: number): void {
    if (!this.groupedAnnexes[index]) {
      this.groupedAnnexes[index] = this.groupAnnexes(this.extensions[index]);
    }
    this.hasAnnexes = this.groupedAnnexes[index].length > 0;
    this.dataSource = new MatTableDataSource(this.groupedAnnexes[index]);
    this.dataSource.sort = this.sort;
  }

  private groupAnnexes(validExtensions: any[]) {
    let merged = [].concat.apply([], this.visit.anexos.map((annexe: any) => annexe.files));
    if (this.allAnnexes.length <= 0) {
      this.allAnnexes = Array.from(merged);
    }
    merged =  merged.filter((item: any) => {
      return validExtensions.some(ext => item.fileName?.toLowerCase().includes(ext) || item.url.toLowerCase().includes(ext));
    });
    return merged;
  }

  viewFile(file: IAnnexFile, index: number): void {
    const windowImage = window.open(file.url);
    if (windowImage) {
      windowImage.document.write(`
      <div style="text-align:center;">
        <img src="${file.url}" style="
        width: auto;
        height: auto;
        max-height: 600px;
        max-width: 800px;
        margin: 20px auto;">
      </div>
    `);
      windowImage.document.title = file.fileName ?? `Imagen ${index}`;
      windowImage.document.body.style.margin = '0';
      windowImage.document.body.style.backgroundColor = '#0e0e0e';
    }
  }

  downloadFile(file: IAnnexFile, name: string) {
    console.log(file);
    try {
      this.visitService.downloadAnnexes(file.url, name);
    } catch (e) {
      window.open(file.url, '_blank');
    }
  }

  downloadAll() {
    this.generatingZip = true;
    this.visitService.generateZippedAnnexes(this.allAnnexes, this.visit.id)
      .valueChanges
      .pipe(
        map((result: any) => result.data.generateZippedAnnexes.response.zip)
      )
      .subscribe((result: any) => {
        this.visitService.downloadAnnexes(result);
        this.generatingZip = false;
      });
  }

  private mapAnnexes(annexes: Annex[]): Annex[] {
    return annexes.map((annex, index) => {
      const files: IAnnexFile[] = [];
      const fileNames = annex.nombre_archivos || [];
      annex.archivos.forEach((f: any, i: number) => {
        const fileName = fileNames[i] ?? '';
        files.push({
          displayName: fileName.split('.').slice(0, -1).join('.'),
          url: f,
          fileName,
        });
      });
      return { ...annex, files };
    });
  }

}
